import PropTypes from 'prop-types';
import {
  fieldListProp,
  textProp,
} from '../../../tools/customProps';

export const MarketingBrandsPropTypes = {
  handleMarketingBrandsChange: PropTypes.func.isRequired,
  isMarketingBrandChecked: PropTypes.func.isRequired,
  marketingBrandsField: PropTypes.shape({ name: PropTypes.string }).isRequired,
  marketingBrandsGroup: PropTypes.shape({ fieldList: fieldListProp }).isRequired,
};

export const MarketingBrandsDefaultProps = {};

export const LegalTextPropTypes = {
  text: textProp.isRequired,
};

export const LegalSectionPropTypes = {
  joinFormPrivacyTerms: PropTypes.shape({ text: textProp }),
  joinLegalCheck: PropTypes.bool,
  joinLegalText: textProp,
  legalField: PropTypes.shape({
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.bool,
  }),
  legalFieldState: PropTypes.shape({ invalid: PropTypes.bool }),
};

export const LegalSectionDefaultProps = {
  joinFormPrivacyTerms: null,
  joinLegalCheck: false,
  joinLegalText: null,
  legalField: {},
  legalFieldState: {},
};
